import React from 'react';
import PropTypes from 'prop-types';

import { crudConfig, uiConfig } from '../../conf/lists';

// API Hooks
import { useGetLists } from '../api/hooks/useGetLists';

// UI Components
import { Button } from '../../../components/Button';
import Table from '../../../components/Table';
import AddEdit from './addEdit';
import { DeleteList } from './deleteList';

import { translateUIConfigForTable, translateUIConfigForAddEdit } from '../../../common/utility';

const { READ_ONLY_FEATURES } = process.env;

const ListManager = ({ userContext }) => {
    const { sessionToken } = userContext;
    const [editing, setEditing] = React.useState(null);
    const [deleting, setDeleting] = React.useState(null);
    const [fatalError, setFatalError] = React.useState(null);
    const saveDisabled = READ_ONLY_FEATURES === 'true';
    const { data, isLoading } = useGetLists(crudConfig, sessionToken);
    const { columns, actions, initialState } = translateUIConfigForTable(uiConfig, setEditing, setDeleting);
    const tableData = React.useMemo(() => {
        if (!data) return [];
        if (actions != null) {
            return actions != null
                ? data.map((v) => ({
                      ...v,
                      DataTableActions: actions.map((i) => ({
                          ...i,
                          action: () => i.action(v[uiConfig.primaryKey])
                      }))
                  }))
                : data;
        }
    }, [data, actions]);

    // const unmountDataCheck = (updated, deleted) => {
    //     if (typeof updated === 'object') {
    //         if (Object.keys(updated).length > 0 || deleted.length > 0) {
    //             return 'You have unsaved changed, are you sure you wish to leave';
    //         }
    //     }
    // };

    // useEffect(() => {
    //     window.onbeforeunload = () => unmountDataCheck(updated, deleted);
    // }, [updated, deleted]);

    // useEffect(() => {
    //     if (fatalError !== null) {
    //         throw fatalError;
    //     }
    // });

    // useEffect(() => {
    //     return () => {
    //         unmountDataCheck();
    //     };
    // }, []);
    const getItemByListId = React.useCallback(
        (id) => {
            return tableData.find((item) => item[uiConfig.primaryKey] === id);
        },
        [tableData]
    );

    const fetchDeleteData = () => {
        return getItemByListId(deleting);
    };

    const closeAddEdit = () => {
        setEditing(null);
    };

    const closeDelete = () => {
        setDeleting(null);
    };
    const isExistingDoc = (doc) => {
        return (
            (data ?? []).find((v) => {
                return (
                    v.listId !== doc.listId && v.code === doc.code && v.name === doc.name && v.listType === doc.listType
                );
            }) !== undefined
        );
    };

    const controlButtons = [];
    if (crudConfig.functions.insert) {
        controlButtons.push(
            <Button key={'add-new'} appearance="primary" onClick={() => setEditing('new')}>
                Add New List
            </Button>
        );
    }

    return (
        <>
            <Table
                withHeader={true}
                columns={columns}
                data={tableData}
                withActions={actions !== null}
                id={'list-manager'}
                label={'Lists'}
                showControlDeck={true}
                paginated={true}
                loading={isLoading}
                controlButtons={controlButtons}
                initialState={initialState}
            />
            {editing != null && (
                <AddEdit
                    formModel={translateUIConfigForAddEdit(uiConfig)}
                    saveDisabled={saveDisabled}
                    selectedListId={editing}
                    closeDialog={closeAddEdit}
                    sessionToken={sessionToken}
                    isExistingDoc={isExistingDoc}
                    onMount={typeof uiConfig.onFormMount === 'function' && uiConfig.onFormMount}
                />
            )}
            {deleting != null ? (
                <DeleteList data={fetchDeleteData()} closeDialog={closeDelete} sessionToken={sessionToken} />
            ) : null}
        </>
    );
};

export default ListManager;

ListManager.propTypes = {
    userContext: PropTypes.object
};
